import React from "react";
import { Button } from "@/components/ui/button";
import { Users, Building2, ArrowLeft } from "lucide-react";
import partnersLogo from "@/assets/partners_logo.png";
import type { PartnerType } from "@/pages/AuthPage";

interface RoleSelectorProps {
  onSelect: (type: PartnerType) => void;
  onBack: () => void;
}

export const RoleSelector: React.FC<RoleSelectorProps> = ({ onSelect, onBack }) => {
  return (
    <div className="auth-glass w-full rounded-2xl border border-white/10 bg-black/40 shadow-2xl backdrop-blur-xl">
      <div className="text-center pt-8 pb-2 px-4">
        <img src={partnersLogo} alt="Silva Partners" className="mx-auto h-16 sm:h-20 mb-3" />
        <h1 className="text-2xl sm:text-3xl text-foreground" style={{ fontFamily: "AwesomeSerif, serif" }}>Silva Partners</h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-1">Como você quer se cadastrar?</p>
      </div>

      <div className="px-6 sm:px-8 pb-8 pt-4 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <button
            type="button"
            onClick={() => onSelect("influencer")}
            className="group flex flex-col items-center gap-3 rounded-xl border border-white/10 bg-white/5 p-6 text-center transition-all hover:border-primary/50 hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <div className="rounded-full bg-primary/15 p-3 transition-colors group-hover:bg-primary/25">
              <Users className="h-8 w-8 text-primary" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-base">Sou Influenciador</p>

            </div>
          </button>

          <button
            type="button"
            onClick={() => onSelect("staff")}
            className="group flex flex-col items-center gap-3 rounded-xl border border-white/10 bg-white/5 p-6 text-center transition-all hover:border-primary/50 hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <div className="rounded-full bg-primary/15 p-3 transition-colors group-hover:bg-primary/25">
              <Building2 className="h-8 w-8 text-primary" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-base">Sou Colaborador SILVA</p>

            </div>
          </button>
        </div>

        <div className="text-center pt-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onBack}
            className="text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Voltar ao login
          </Button>
        </div>
      </div>
    </div>
  );
};
